import { execute } from '@tutorabc/webview-jsbridge'

// constants
import { BRIDGE_HANDLER } from '@/constants/bridgeHandler'

type EnterLiveRoomDetailsParams = {
  id: string
}

export const enterLiveRoomDetails = ({ id }: EnterLiveRoomDetailsParams) => {
  execute({
    handlerName: BRIDGE_HANDLER.OPEN_ROOM_DETAIL,
    data: { id },
  })
}
